'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.toggleValidityClass = toggleValidityClass;
exports.input = input;
exports.disableSubmitButton = disableSubmitButton;
exports.form = form;
var IS_VALID_CLASS = 'is-valid';
var IS_INVALID_CLASS = 'is-invalid';
var IS_ACTIVE_CLASS = 'is-active';
var HELP_ELEMENT_SELECTOR = '.gzl-FormField-help';
var ERROR_ELEMENT_SELECTOR = '.gzl-FormField-error';
var SUCCESS_ELEMENT_SELECTOR = '.gzl-FormField-success';
var SUBMIT_ELEMENT_SELECTOR = '[type="submit"]';
var INPUT_ELEMENT_SELECTOR = '.gzl-Checkbox, .gzl-Input, .gzl-Radio, .gzl-Select, .gzl-Textarea, .gzl-Toggle';
var DATA_ENABLE_WITH = 'data-enable-with';
var DEFAULT_DATA_DISABLE_WITH = 'data-disable-with';
var SUCCESS = 'success';
var ERROR = 'error';
var DISABLED = 'disabled';
var DEFAULT_OPTIONS = {
  disableWithAttr: DEFAULT_DATA_DISABLE_WITH
};
var mergedOptions = DEFAULT_OPTIONS;

function _mergeOptions(customOptions) {
  mergedOptions = _extends({}, DEFAULT_OPTIONS, customOptions);
}

function _formFieldForInput(inputElement) {
  var control = inputElement.parentNode.parentNode;
  var element = control.parentNode;

  return {
    control: control,
    element: element,
    error: function error() {
      return element.querySelector(ERROR_ELEMENT_SELECTOR);
    },
    help: element.querySelector(HELP_ELEMENT_SELECTOR),
    input: inputElement,
    inputName: inputElement.name,
    success: function success() {
      return element.querySelector(SUCCESS_ELEMENT_SELECTOR);
    },
    value: function value() {
      return inputElement.value;
    }
  };
}

function _validityType(validityState) {
  var key;

  for (key in validityState) {
    if (validityState[key] === true) {
      return key;
    }
  }

  return '';
}

function toggleValidityClass(element, isValid) {
  element.classList.remove(isValid ? IS_INVALID_CLASS : IS_VALID_CLASS);
  element.classList.add(isValid ? IS_VALID_CLASS : IS_INVALID_CLASS);
}

function _displayFieldValidity(valid, inputOrFormField, message) {
  var formField = inputOrFormField.nodeType === 1 ? _formFieldForInput(inputOrFormField) : inputOrFormField;
  var messageType = valid ? SUCCESS : ERROR;
  var oppositeMessageType = valid ? ERROR : SUCCESS;

  toggleValidityClass(formField.element, valid);

  if (formField[oppositeMessageType]()) {
    formField.element.removeChild(formField[oppositeMessageType]());
  }
  if (!message) {
    return;
  } else if (formField[messageType]()) {
    formField[messageType]().innerHTML = message;
  } else {
    var insertAfterElement = formField.help || formField.control;
    insertAfterElement.insertAdjacentHTML('afterend', '<p class="gzl-FormField-' + messageType + '">' + message + '</p>');
  }
}
var displayErrorValidity = exports.displayErrorValidity = _displayFieldValidity.bind(null, false);
var displaySuccessValidity = exports.displaySuccessValidity = _displayFieldValidity.bind(null, true);

function _processValidity(errorMessages, formField, type) {
  var valid = type === 'valid',
      callbackId = valid ? 1 : 0,
      message = type === 'customError' && formField.input.validationMessage || errorMessages[type] || formField.input.validationMessage;

  if (Array.isArray(errorMessages) && errorMessages[callbackId]) {
    errorMessages[callbackId](formField);
  } else {
    _displayFieldValidity(valid, formField, message);
  }
}

function _evalValidity(inputElement, customError) {
  var validEvent = new CustomEvent('valid', {
    bubbles: false,
    cancelable: true
  });

  if (typeof customError === 'string') {
    inputElement.setCustomValidity(customError);
  }

  inputElement.checkValidity();

  if (inputElement.validity.valid) {
    inputElement.dispatchEvent(validEvent);
  }

  return inputElement.validity.valid;
}

function _checkCustomValidity(errorMessages, inputElement, validationCallback) {
  inputElement.setCustomValidity('');
  if (typeof errorMessages.customError === 'function' && inputElement.validity.valid) {
    return errorMessages.customError(inputElement, validationCallback);
  }
  return validationCallback('');
}

function _checkValidity(errorMessages, inputElement) {
  return new Promise(function (resolve) {
    _checkCustomValidity(errorMessages, inputElement, function (customError) {
      resolve(_evalValidity(inputElement, customError));
    });
  });
}

function input(errorMessages, inputElement) {
  var formField = _formFieldForInput(inputElement);
  function inputHandler() {
    formField.input.removeEventListener('input', inputHandler);
    _checkValidity(errorMessages, formField.input);
  }
  function blurHandler() {
    if (formField.value().length || formField.success()) {
      _checkValidity(errorMessages, formField.input);
    }
  }
  function validityHandler() {
    _processValidity(errorMessages, formField, _validityType(formField.input.validity));
    formField.input.addEventListener('input', inputHandler);
  }

  formField.input.addEventListener('blur', blurHandler);
  formField.input.addEventListener('invalid', validityHandler);
  formField.input.addEventListener('valid', validityHandler);

  return {
    name: formField.input.name,
    validate: _checkValidity.bind(null, errorMessages, formField.input)
  };
}

function _buildInputs(errorMessages, collectedConfig, element) {
  // First child doesn't work here because we need access to the name attribute
  var inputElement = element.children[0];
  var elementErrorMessages = errorMessages[inputElement.name];
  var inputArgs = [elementErrorMessages, inputElement];

  if (!elementErrorMessages) {
    return collectedConfig;
  }

  input.apply(undefined, inputArgs);
  collectedConfig[inputElement.id] = inputArgs;

  return collectedConfig;
}

function _submitButtonTextIsNotOriginalText(originalText, newText) {
  return originalText !== newText;
}

function _setSubmitButtonText(submitButton, attrToSet, text) {
  submitButton[attrToSet] = text;
}

function _disableSubmitButton(submitButton) {
  submitButton.setAttribute(DISABLED, true);
  submitButton.classList.add(IS_ACTIVE_CLASS);
}

function _enableSubmitButton(submitButton) {
  submitButton.removeAttribute(DISABLED);
  submitButton.classList.remove(IS_ACTIVE_CLASS);
}

function disableSubmitButton(formElement, disabled) {
  var customOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _mergeOptions(customOptions);
  var submitButton = formElement.querySelector(SUBMIT_ELEMENT_SELECTOR),
      valueAttr = submitButton.tagName === 'BUTTON' ? 'textContent' : 'value',
      activeText = submitButton.getAttribute(mergedOptions.disableWithAttr),
      originalText = submitButton[valueAttr];

  if (_submitButtonTextIsNotOriginalText(originalText, activeText)) {
    submitButton.setAttribute(DATA_ENABLE_WITH, originalText);
  }

  if (disabled) {
    _disableSubmitButton(submitButton);
    if (activeText) {
      _setSubmitButtonText(submitButton, valueAttr, activeText);
    }
  } else {
    var buttonText = submitButton.getAttribute(DATA_ENABLE_WITH) || activeText;

    _enableSubmitButton(submitButton);
    _setSubmitButtonText(submitButton, valueAttr, buttonText);
  }
}

function _sendFormInvalidEvent(formElement) {
  var formifierInvalid = new CustomEvent('formifierInvalid', {
    bubbles: false,
    cancelable: true,
    detail: formElement
  });
  formElement.dispatchEvent(formifierInvalid);
}

function _submitForm(formElement, submitCallback) {
  var formifierSubmit = new CustomEvent('formifierSubmit', {
    bubbles: true,
    cancelable: true,
    detail: formElement
  });
  if (typeof submitCallback === 'function') {
    submitCallback(formElement);
  } else {
    formElement.submit();
  }
  formElement.dispatchEvent(formifierSubmit);
}

function _submitFormIfValid(formElement, customValidatorValidity, submitCallback) {
  var validForm = Object.keys(customValidatorValidity).every(function (item) {
    return customValidatorValidity[item] === true;
  });
  if (!validForm || !formElement.checkValidity()) {
    disableSubmitButton(formElement, false);
    return;
  }

  disableSubmitButton(formElement, true);
  _submitForm(formElement, submitCallback);
}

function _submitHandler(formConfig, formElement, submitCallback, event) {
  event.preventDefault();

  var customValidatorValidity = {},
      formValid = formElement.checkValidity();

  Object.keys(formConfig).forEach(function (inputName) {
    customValidatorValidity[inputName] = null;
  });

  Object.keys(formConfig).forEach(function (inputName) {
    var inputErrorMessages = formConfig[inputName][0],
        inputElement = formConfig[inputName][1];

    _checkCustomValidity(inputErrorMessages, inputElement, function (validityResult) {
      customValidatorValidity[inputName] = _evalValidity(inputElement, validityResult);
      _submitFormIfValid(formElement, customValidatorValidity, submitCallback);
    });
  });

  if (formValid) {
    disableSubmitButton(formElement, true);
    if (!Object.keys(customValidatorValidity).length) {
      _submitForm(formElement, submitCallback);
    }
    return;
  }
  _sendFormInvalidEvent(formElement);
}

function form(errorMessages, formElement, submitCallback) {
  var customOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _mergeOptions(customOptions);

  // eslint-disable-next-line prefer-reflect
  var formConfig = Array.prototype.reduce.call(formElement.querySelectorAll(INPUT_ELEMENT_SELECTOR), _buildInputs.bind(null, errorMessages), {});

  formElement.noValidate = true;
  formElement.addEventListener('submit', _submitHandler.bind(null, formConfig, formElement, submitCallback));
}